import { Redirect, Route } from 'react-router-dom';

const ProtectedRoute = ({ component: Component, role = 'REPRESENTATIVE', ...rest }) => {
  const isAuthenticated =
    !!localStorage.getItem('token') && localStorage.getItem('role') === role;

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )
      }
    />
  );
};

export default ProtectedRoute;
